module.exports = __webpack_public_path__ + "img/heart_emoji.a6d5ce5.png";